import { User } from 'api/models';
import { Field } from 'api/tasks';
import { IntegrationStatusTypes } from 'components/organisms/module-settings/integrations/integrations-list/authentication-types';
import { FieldType } from 'components/organisms/tasks/fields';

export type IntegrateFieldOption = {
  label: string;
  valueStr: string;
  active?: boolean;
  integrationFieldId?: string;
  valueMeta?: any;
};

export interface IntegrationField
  extends Omit<Field, 'fieldId' | 'metaData' | 'fieldType'> {
  parentFieldName: string;
  integrationFieldId: string;
  fieldType: FieldType;
  type?: FieldType;
  required?: boolean;
  fieldValue?: string;
  editableByFieldMapping?: boolean;
  metaData?: {
    options?: IntegrateFieldOption[];
    rangeAvailable?: boolean;
    range?: {
      min?: number;
      max?: number;
    };
    default?: any;
  };
}

export type FieldValue = {
  integrationFieldId: string;
  valueStr: string;
};

export type IntegrationConfig<SettingsMeta> = {
  integrationId: number;
  integrationType: string;
  domain: string;
  settingsMeta: SettingsMeta;
  integrationStatus: IntegrationStatusTypes;
  meta: {
    oauthAuthenticatorAccountId: string;
    oauthAuthenticatorEmail: string;
    salesforceEnv?: string;
    oauthAuthenticatorAccountUrl?: string;
  };
  createdBy: User;
};

export enum AutomationErrorTypes {
  DuplicateAutomation = 'CONFLICTING_FIELD_VALUE',
}
export type AutomationCreationError = {
  code: AutomationErrorTypes;
  field: string;
  reason: string;
};

export type IntegrationProviderMeta = {
  authType: string;
  oauthUrl: string;
  oauthReauthUrl: string;
};

export enum ThirdpartyIntegrationType {
  Slack = 'slack',
  Jira = 'jira',
  Salesforce = 'salesforce',
  Rocketlane = 'rocketlane',
  Form = 'FORM',
}

export interface ExternalUser {
  id: string;
  integrationType: ThirdpartyIntegrationType;
  name: string;
  key: string;
  rlUserId: number;
}
